import axios from "../interceptors/axios";
import { getSearchProjects } from "@/server/workService";

const ADMIN_HOME_EXCLUSIVES_URL = "/api/admin/home/exclusive-projects";

function unwrap(response) {
  return response?.data || response || {};
}

export default class AdminHomeExclusivesService {
  list = async () => {
    const response = await axios.get(ADMIN_HOME_EXCLUSIVES_URL);
    return unwrap(response);
  };

  create = async (projectId) => {
    const response = await axios.post(ADMIN_HOME_EXCLUSIVES_URL, {
      project_id: projectId,
    });
    return unwrap(response);
  };

  reorder = async (items) => {
    const response = await axios.put(`${ADMIN_HOME_EXCLUSIVES_URL}/reorder`, {
      items,
    });
    return unwrap(response);
  };

  update = async (id, payload) => {
    const response = await axios.patch(`${ADMIN_HOME_EXCLUSIVES_URL}/${id}`, payload);
    return unwrap(response);
  };

  remove = async (id) => {
    const response = await axios.delete(`${ADMIN_HOME_EXCLUSIVES_URL}/${id}`);
    return unwrap(response);
  };

  searchProjects = async (params = {}) => {
    return getSearchProjects(params);
  };
}
